<template>
  <div class="wrapper">
    <div class="content-box">
      <form class="form-global" novalidate @submit.prevent="validateData">
        <h3>
          {{$t('register.text.session_companie')}}
        </h3>
        <md-field class="corporateName" :class="getValidationClass('corporateName')">
          <label>{{$t('register.form.corporate_name')}}</label>
          <md-input v-model="formRegister.corporateName" required />
          <span class="md-error" v-if="!$v.formRegister.corporateName.required">
            {{$t('register.validate.fild_required')}}
          </span>
          <span class="md-error" v-if="!$v.formRegister.corporateName.minLength">
            {{$t('register.validate.fild_minlength')}}
          </span>
        </md-field>
        <md-field class="telephoneCompanie" :class="getValidationClass('telephoneCompanie')">
          <label>{{$t('register.form.telephone_companie')}}</label>
          <md-input
            v-model="formRegister.telephoneCompanie"
            v-mask="['(##) ####-####', '(##) #####-####']"
            required
          />
          <span class="md-error" v-if="!$v.formRegister.telephoneCompanie.required">
            {{$t('register.validate.fild_required')}}
          </span>
          <span class="md-error" v-if="!$v.formRegister.telephoneCompanie.minLength">
            {{$t('register.validate.fild_telephone')}}
          </span>
        </md-field>
        <md-field class="mailCompanie" :class="getValidationClass('mailCompanie')">
          <label>{{$t('register.form.mail_companie')}}</label>
          <md-input v-model="formRegister.mailCompanie" />
        </md-field>
        <h3>
          {{$t('register.text.session_user')}}
        </h3>
        <md-field class="nameUser" :class="getValidationClass('nameUser')">
          <label>{{$t('register.form.name_user')}}</label>
          <md-input v-model="formRegister.nameUser" required />
          <span class="md-error" v-if="!$v.formRegister.nameUser.required">
            {{$t('register.validate.fild_required')}}
          </span>
          <span class="md-error" v-if="!$v.formRegister.nameUser.minLength">
            {{$t('register.validate.fild_minlength')}}
          </span>
        </md-field>
        <md-field class="mailUser" :class="getValidationClass('mailUser')">
          <label>{{$t('register.form.mail_user')}}</label>
          <md-input v-model="formRegister.mailUser" required />
          <span class="md-error" v-if="!$v.formRegister.mailUser.required">
            {{$t('register.validate.fild_required')}}
          </span>
          <span class="md-error" v-if="!$v.formRegister.mailUser.email">
            {{$t('register.validate.fild_email')}}
          </span>
        </md-field>
        <md-field class="passwordUser" :class="getValidationClass('passwordUser')">
          <label>{{$t('register.form.password_user')}}</label>
          <md-input v-model="formRegister.passwordUser" type="password" required />
          <span class="md-error" v-if="!$v.formRegister.passwordUser.required">
            {{$t('register.validate.fild_required')}}
          </span>
          <span class="md-error" v-if="!$v.formRegister.passwordUser.minLength">
            {{$t('register.validate.fild_minlength')}}
          </span>
        </md-field>
        <p class="terms">
          {{$t('register.text.concord_terms')}}
          <router-link
            to="/terms"
            target="_blank"
          >
            {{$t('register.text.terms_using')}}.
          </router-link>
        </p>
        <btn
          :description="$t('index.pricing.register')"
          medium
          class="btn"
          :disabled="request"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  name: 'form-registration',
  props: {
    dataForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formRegister: {
        corporateName: '',
        telephoneCompanie: '',
        mailCompanie: '',
        nameUser: '',
        mailUser: '',
        passwordUser: '',
      },
      request: false,
    };
  },
  validations: {
    formRegister: {
      corporateName: { required, minLength: minLength(6) },
      telephoneCompanie: { required, minLength: minLength(14) },
      nameUser: { required, minLength: minLength(3) },
      mailUser: { required, email },
      passwordUser: { required, minLength: minLength(6) },
    },
  },
  mounted() {
    if (this.dataForm && this.dataForm.nameUser && this.dataForm.mailUser) {
      this.formRegister.nameUser = this.dataForm.nameUser;
      this.formRegister.mailUser = this.dataForm.mailUser;
    }
  },
  methods: {
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.sendData();
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.formRegister[fieldName];
      return (field) ? { 'md-invalid': field.$invalid && field.$dirty } : '';
    },
    async sendData() {
      this.request = true;
      this.$Services.requestAccount.companiePost({
        name: this.formRegister.corporateName,
        telephone: this.formRegister.telephoneCompanie,
        email: this.formRegister.mailCompanie,
        nameUser: this.formRegister.nameUser,
        emailUser: this.formRegister.mailUser,
        password: this.formRegister.passwordUser,
      }).then((res) => {
        this.request = false;
        if (res.success) {
          this.$Notification.open(
            this.$t('register.notifications.success'),
            'success',
          );
          setTimeout(() => {
            /* eslint-disable */
              location.replace('https://app.represente.com.br');
            /* eslint-enable */
          }, 1500);
        } else {
          this.$Notification.open(
            this.$t('register.notifications.error'),
            'error',
          );
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .wrapper
    width: 60%
    .form-global
      display: flex
      flex-wrap: wrap
      justify-content: flex-end
      h3, .terms
        width: 100%
      .terms,.terms a
        margin-bottom: 12px
        font-size: 14px
        font-style: italic
        font-weight: 300
        a
          font-weight: 400
          text-decoration: underline
    @media (max-width: $widthTerciary)
      width: 100%
</style>
